import React, { Component } from 'react';
import PropTypes from 'prop-types';

const MULTIPLE = 'multiple';

class WveInputText extends Component {
  render() {
    const { value, onChange, placeholder, pattern, onBlur, disabled } = this.props;
    const isMultiple = value === MULTIPLE;
    const patternToUse = isMultiple ? '' : pattern;
    return (<input
      type="text"
      className="wve-form-item wve-form-item-long form-control input-sm"
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      disabled={disabled}
      pattern={patternToUse}
      onBlur={onBlur}
    />);
  }
}

WveInputText.defaultProps = {
  value: '',
  placeholder: '',
  pattern: '',
  onBlur: null,
  disabled: false,
};

WveInputText.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  pattern: PropTypes.string,
  onBlur: PropTypes.func,
  disabled: PropTypes.bool,
};

export default WveInputText;



// WEBPACK FOOTER //
// ./app/javascript/packs/Shared/components/WveInputs/WveInputText/WveInputText.jsx